import React from 'react';
import {
  BEACON_SEARCH_INPUT,
  BEACON_SEARCH_POSTS,
  BEACON_SEARCH_TARGETS,
  TUTORIAL_NAME_SEARCH,
} from '../../constants/onboarding';
import beginning from '../../images/tutorials/search/beginning.png';
import end from '../../images/tutorials/search/end.png';
import facets from '../../images/tutorials/search/facets.gif';
import input from '../../images/tutorials/search/input.gif';
import results from '../../images/tutorials/search/results.gif';
import targets from '../../images/tutorials/search/targets.gif';
import useNavigate from '../../utils/router/useNavigate';
import Tutorial from './Tutorial';

const SearchTutorial = () => {
  const navigate = useNavigate();
  const navigateToSearch = () => {
    if (!document.location.pathname.startsWith('/search')) {
      navigate('/search?q=company');
    }
  };

  return (
    <Tutorial
      name={TUTORIAL_NAME_SEARCH}
      steps={[
        {
          title: 'Learn how to Search',
          message:
            'Locating a key piece of information should be fast and easy. Search through your posts, comments, and even from third party tools like Slack and Google Drive.',
          imageUrl: beginning,
        },
        {
          title: 'Search Slab',
          message:
            "As soon as you focus the search bar, Slab surfaces items you've recently viewed that you can jump to directly. Begin typing to narrow down matches, all without having to leave the page.",
          beacons: [BEACON_SEARCH_INPUT],
          imageUrl: input,
        },
        {
          title: 'Blazing results',
          message:
            'Just hit enter to search and Slab will bring you fast, relevant results. Search is full-text, showing exactly where your query appears in each result.',
          beacons: [BEACON_SEARCH_POSTS],
          imageUrl: results,
          onActive: navigateToSearch,
        },
        {
          title: 'Scoping',
          message:
            "You can scope down your search results within a specific topic by typing 'in:{topic name}' — give 'by:' and 'is:' a try too!",
          imageUrl: facets,
        },
        {
          title: 'Unified search',
          message:
            'Answers can live in any of the tools your team uses. Slab integrates with them, so you can search in one place to get to all of the answers.',
          beacons: [BEACON_SEARCH_TARGETS],
          imageUrl: targets,
          onActive: navigateToSearch,
        },
        {
          title: 'Get searching!',
          message:
            'You can set up your integrations on the search results page, tailored and private to you. Search away!',
          imageUrl: end,
        },
      ]}
    />
  );
};

export default SearchTutorial;
